import React, { useRef } from "react";

const Banner = () => {
  const containerRef = useRef(null);

  return (
    <section className="international-banner">
      <div className="container">
        {/* Text Content */}
        <div className="text-content">
          <h1 data-sal="fade" data-sal-duration="800" data-sal-delay="200">Expert Gastro Care</h1>
          <p data-sal="fade" data-sal-duration="800" data-sal-delay="400">
            At Lifeline Tulasi Hospital, our Gastroenterology specialists provide
            advanced diagnosis and treatment for digestive health issues. From
            acid reflux to liver disorders, we ensure personalized care with
            cutting-edge technology.
          </p>
        </div>

        {/* Image and Orbit Icons */}
        <div className="image-content" ref={containerRef} data-sal="zoom-in" data-sal-duration="1000" data-sal-delay="300">
            <img src="/assets/img/international_page_banner.png" alt="international_page_banner" />
        </div>
      </div>
    </section>
  );
};

export default Banner;
